module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.active) ? _c('div', {
    staticClass: "signupContainer"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.active = false
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('p', [_vm._v("Want to infrequently hear about new musicboxes and other UCC projects? Add your email below")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('button', {
    on: {
      "click": _vm.newsletterSignup
    }
  }, [_vm._v("Sign Up")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d0c6c33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/u3c/newsletterSignup.vue
// module id = 269
// module chunks = 1